export const palette = {
  mainColor: "#1D57C1",
  subColor: "#7EACFF",
  textPoint: "#002D7D",
  textRedPoint: "#FF2F7A",
  textDark: "#404040",
  lineColor: "#E7EFFF",
  white: "#FFFFFF",
  veryLigntGray: "#F2F2F2",
  lightGray: "#DBDBDB",
  middleGray: "#C4C4C4",
  darkGray: "#767676"
};
